import script from "./CompletedApp.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletedApp.vue?vue&type=script&setup=true&lang=js"

import "./CompletedApp.vue?vue&type=style&index=0&id=63083ae6&lang=css"

const __exports__ = script;

export default __exports__